import React from "react";
import "./Home.css";

const News = ({ date, title, contents }) => {
    return (
        <div className="news-wrapper">
 
            <div className="news-contents-wrapper">
                <div className="news-date news-elements">
                    {date}
                </div>
                <div className="news-title news-elements">
                    <span className="news-title-name">{title}</span>
                </div>
                <div className="news-contents news-elements">
                    {contents}
                </div>

            </div>
        </div>
    );
}

export default News;